module.exports = __webpack_public_path__ + "static/img/暂无排班@2x.5de1f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无排班@2x.png
// module id = 290
// module chunks = 363 364